import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconComputerUse: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"computer-use, cursor"} maskId="square-filled-radius-0-stroke-1-IconComputerUse"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM10.75 17.541L12.4473 12.4473L17.541 10.75L7.35449 7.35449L10.75 17.541Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconComputerUse;
